import React, {cloneElement} from 'react'

import {PositioningPortal} from '@codastic/react-positioning-portal'

import cn from '../../libs/class-names'

import chevronDownIcon from '../../assets/icons/chevron-down.svg'

import Icon from '../icon'

const positionStrategy = (parentRect: ClientRect, portalRect: ClientRect) => {
  // Open the content portal above the child if there is not enough space to the bottom,
  // but if there also isn't enough space at the top, open to the bottom and align to the bottom.
  const openAbove =
    parentRect.top + parentRect.height + portalRect.height >
      (window.document.documentElement || window.document.body).clientHeight &&
    parentRect.top - portalRect.height > 0

  const top = openAbove
    ? parentRect.top - portalRect.height + window.scrollY
    : parentRect.top + parentRect.height + window.scrollY

  // Open the content portal to the left if there is not enough space at the right,
  // but if there also isn't enough space at the right, open to the left.
  const alignRight =
    parentRect.left + portalRect.width >
      (window.document.documentElement || window.document.body).clientWidth &&
    parentRect.left - portalRect.width > 0

  const left = !alignRight
    ? parentRect.left + window.scrollX
    : window.scrollX + parentRect.left - portalRect.width + parentRect.width

  return {
    top,
    left,
    strategy: null,
  }
}

export interface Props {
  classNames?: string[]
  label: string
  isOpen: boolean
  menu: React.ReactElement
  onClick: React.MouseEventHandler
  onShouldClose: () => void
  active?: boolean
  disabled?: boolean
  size?: '100' | '90'
}

const FilterSelect = ({
  classNames,
  label,
  isOpen,
  menu,
  onClick,
  onShouldClose,
  active = false,
  disabled = false,
  size = '100',
}: Props) => {
  const mainContent = (
    <button
      className={cn(
        'FilterSelect',
        {
          open: isOpen,
          active,
          disabled,
          [`size-${size}`]: !!size,
        },
        classNames
      )}
      onClick={onClick}
      type="button"
      disabled={disabled}
    >
      <span className="FilterSelect__label">{label}</span>
      <span className="FilterSelect__icon">
        <Icon source={chevronDownIcon} />
      </span>
    </button>
  )

  if (menu) {
    return (
      <PositioningPortal
        isOpen={isOpen}
        portalElement={<div className="FilterSelect__menu" />}
        onShouldClose={onShouldClose}
        positionStrategy={positionStrategy}
        portalContent={
          <>
            {cloneElement(menu, {
              onClose: () => {
                onShouldClose()
              },
              onSubmit: (...args: unknown[]) => {
                onShouldClose()
              },
            })}
          </>
        }
      >
        {mainContent}
      </PositioningPortal>
    )
  }

  return mainContent
}

export default FilterSelect
